export function ensureDefined<T>(value: T | undefined): T {
  if (!value) {
    throw new Error('Unexpected: value is expected, but undefined.')
  }
  return value
}
